
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderProductsGrid extends Serenity.EntityGrid<OrderProductsRow, any> {
        protected getColumnsKey() { return OrderProductsColumns.columnsKey; }
        protected getDialogType() { return OrderProductsDialog; }
        protected getIdProperty() { return OrderProductsRow.idProperty; }
        protected getInsertPermission() { return OrderProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }
        protected getService() { return OrderProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderProductsService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}